import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Routes } from '../../config/routes';
import { LegFiJwtService } from '../auth/legfi-jwt.service';
import { JwtLegFiClaims } from '../auth/jwt-legfi-claims.model';
import { ApplicationHttpClient } from '../../components/shared/http/application-http-client';
import { Note } from '../../models/entities/note';

@Injectable({
    providedIn: 'root',
})
export class NotesService
{
    private _http: ApplicationHttpClient;

    constructor(_http: ApplicationHttpClient) {
        this._http = _http;
    }

    getNotes(modelId: number, modelType: string, orgId?: number): Observable<Note[]> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }

        const url: string = Routes.MakeLegFiCoreUrl(
                Routes.LegFiCore.GenericNote(orgId || jwt.orgId, modelId, modelType),
        );

        return this._http.get(url).pipe(map(
                (response: Object[]) => {
                    return response.map((noteData: any) => {
                        return new Note(noteData);
                    });
                },
        ));
    }

    updateNote(noteId: number, request: any, orgId?: number): Observable<Note> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }

        const url: string = Routes.MakeLegFiCoreUrl(
                Routes.LegFiCore.OrgNote(orgId || jwt.orgId, noteId),
        );

        return this._http.patch(url, JSON.stringify(request)).pipe(map(
                (response: Object) => {
                    return new Note(response);
                },
        ));
    }

    addNote(modelId: number, modelType: string, request: any, orgId?: number): Observable<Note> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }

        const url: string = Routes.MakeLegFiCoreUrl(
                Routes.LegFiCore.GenericNote(orgId || jwt.orgId, modelId, modelType),
        );

        return this._http.post(url, JSON.stringify(request)).pipe(map(
                (response: Object) => {
                    return new Note(response);
                },
        ));
    }

    deleteNote(noteId: number, orgId?: number): Observable<Object> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }

        const url: string = Routes.MakeLegFiCoreUrl(
                Routes.LegFiCore.OrgNote(orgId || jwt.orgId, noteId),
        );

        return this._http.delete(url);
    }
}
